import styles from './BrandMark.module.css'

interface Props {
  dimmed?: boolean
}

/** Compact PlayerV mark — no external asset (works in IIFE embed). */
export function BrandMark({ dimmed = false }: Props) {
  return (
    <div className={`${styles.mark}${dimmed ? ` ${styles.dimmed}` : ''}`} aria-hidden>
      <svg viewBox="0 0 40 40" width="36" height="36">
        <defs>
          <linearGradient id="pvBrandGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#e11d2e" />
            <stop offset="100%" stopColor="#ff4d5a" />
          </linearGradient>
        </defs>
        <rect width="40" height="40" rx="10" fill="#12151a" />
        <rect
          x="1"
          y="1"
          width="38"
          height="38"
          rx="9"
          fill="none"
          stroke="url(#pvBrandGrad)"
          strokeWidth="1.5"
          opacity="0.85"
        />
        <path d="M16 12.5v15l12.5-7.5L16 12.5z" fill="url(#pvBrandGrad)" />
      </svg>
    </div>
  )
}
